import React, { useState } from 'react';
import { connect } from 'react-redux';
import { alertActions } from '../../../../../_actions/alert.actions';
import { telehealthActions } from '../../../../../_actions/telehealth.actions';
import { telehealthService as service } from '../../../../../_services/telehealth.service'
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import status from 'http-status';
import NumberFormat from 'react-number-format';

function ResendAction({ loadData, telehealth, dispatch }) {
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState([])
  const [resending, setResending] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);

  const handleShow = () => {
    setPhoneNumber(telehealth.patientPhoneNumber)
    setEmailAddress(telehealth.patientEmailAddress)
    setShow(true);
  }

  const handleClose = () => {
    setPhoneNumber(null)
    setEmailAddress(null)
    setShow(false);
  }

  const renderValidateMessage = (field) => {
    const message = errors[field];
    return (<div id={`${field}-error`} className="text-danger hide">{message}</div>);
  }

  const validate = () => {
    let errors = {};

    if (phoneNumber.length === 0 && emailAddress === "") {
      errors.phoneNumber = 'Cell Phone Number or Email is required.';
      errors.email = 'Cell Phone Number or Email is required.';
    }
    if (phoneNumber !== "" && phoneNumber.length !== 10) {
      errors.phoneNumber = 'Invalid format: Ex: 9091236789.';
    }
    if (emailAddress !== "" && (!emailAddress.includes('@') || !emailAddress.includes('.'))) {
      errors.email = 'Invalid format: Ex: name@email.com';
    }
    setErrors(errors);

    if (!errors.email && !errors.phoneNumber) {
      resend();
    }
  }

  const resend = () => {
    setResending(true);
    service.resend(telehealth, phoneNumber, emailAddress)
      .then(() => {
        setResending(false);
        loadData();
        dispatch(alertActions.success('Telehealth appointment resent!'));
        handleClose();
      })
      .catch((error) => {
        setResending(false);
        handleClose();

        if (error.response && error.response.status === status.UNPROCESSABLE_ENTITY) {
          dispatch(telehealthActions.searchTelehealths());

          dispatch(alertActions.warning(error.response.data.message));
        } else {
          dispatch(alertActions.error('Could not resend at this time. Please try again later.'));
        }
      });
  }

  return <>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Resend</Tooltip>}
    >
      <button onClick={handleShow}
        title="Resend"
        className="btn btn-outline-primary btn-sm">
        <i className="fa fa-undo"></i>
      </button>
    </OverlayTrigger>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Resend Telehealth</Modal.Title>
      </Modal.Header>

      <Modal.Body className="mb-2">
        <h6>Cell Phone Number</h6>
        <NumberFormat
          onValueChange={e => setPhoneNumber(e.value)}
          value={phoneNumber}
          format="###-###-####"
          mask="_"
          name="phoneNumber"
          className={`form-control ${errors.phoneNumber ? 'is-invalid' : ''}`}
          placeholder="___-___-____" />
        {renderValidateMessage('phoneNumber')}
        <br />

        <h6>Email Address</h6>
        <input
          onChange={(e) => setEmailAddress(e.target.value)}
          value={emailAddress}
          type="text"
          name="email"
          className={`form-control ${errors.email ? 'is-invalid' : ''}`}
          placeholder="Enter Email" />
        {renderValidateMessage('email')}
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={validate}
          disabled={resending}
          variant="primary"
        >
          {resending ? 'Resending...' : 'Resend'}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default connect()(ResendAction);